//abdullah
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Input,
  FormGroup,
  CustomInput,
  Label,
} from "reactstrap";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import axios from "axios";
import { Link } from "react-router-dom";
import { GetIp } from "../../Forms/ShortCutComponents/Get_ip";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";
import { csvFileToArray } from "../../Features/Imports/data";
import moment from "moment";
import ItemInvenOpn from "../../Features/Imports/assets/ItemInvenOpn.xlsx";
import {
  checkPermission,
  check_Bussiness_Permission,
  checkBatchNO,
} from "../../../Helper";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

export default function ExcelLoad(props) {
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");
  const companyId = localStorage.getItem("companyId");

  const [fileName, setFileName] = useState("");
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [goodRows, setGoodRows] = useState([]);
  const [badRows, setBadRows] = useState([]);
  const [showBadRows, setShowBadRows] = useState(false);
  const [file, setFile] = useState(null);
  const [disableField, setDisableField] = useState(true);
  const [ipCountry, setIpCountry] = useState({ userIp: "", userCountry: "" });
  const [percentageLoader, setPercentageLoader] = useState(false);
  const [showQty, setShowQty] = useState(false);
  const [crumble, setcrumble] = useState(false);
  const [maxBatchNo, setmaxBatchNo] = useState(0);
  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
      await checkBussinessPermission();
      const No = await checkBatchNO("item_openings");
      setmaxBatchNo(No);
    };
    funCall(1);
    getIpCountry();
  }, []);
  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    console.log("checkBussinessPermission :>> ", checkBussinessPermission);
    let { isCrumble } = checkBussinessPermission;
    if (isCrumble) {
      setcrumble(true);
    }
  };
  const asyncRollCheck = async (value) => {
    let pathname = "/addInvenOpnExcelLoad";
    let status = value;
    return await checkPermission(pathname, status);
  };

  const handleOnChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleOnChangeFile = async () => {
    if (!file) {
      swal({
        title: "File Not Selected!",
        text: "Please Select File",
        icon: "warning",
      });
      return;
    }

    try {
      setLoadingResponse(true);
      const fileName = file.name;
      setFileName(fileName);
      const jsonData = await csvFileToArray(file);
      const nonEmptyArrays = jsonData.filter((arr) => arr.length > 0);

      if (nonEmptyArrays.length === 0) {
        throw new Error("The file contains no valid data");
      }

      // csvFileToArray reads with raw:false, so a cell formatted with a
      // thousands separator arrives as text ("1,250.50"). parseFloat stops at
      // the first comma and MySQL truncates the string the same way, so the
      // row was saved as 1 instead of 1250.50. Strip the commas up front so
      // the preview, the amount calculation and the insert all see the number.
      // Excel's accounting format writes negatives as "(1,250.50)" — turn
      // that into "-1250.50". Anything still not a number is caught as a bad
      // row in verifyExcelData.
      const numericKeys = ["qty", "rate", "amount"];
      const stripCommas = (val) => {
        if (typeof val !== "string") return val;
        const cleaned = val.replace(/,/g, "").trim();
        const bracketed = cleaned.match(/^\((.*)\)$/);
        return bracketed ? `-${bracketed[1].trim()}` : cleaned;
      };

      const keys = nonEmptyArrays[0];
      const dataObjects = nonEmptyArrays.slice(1).map((row) => {
        const obj = {};
        keys.forEach((key, index) => {
          obj[key] = numericKeys.includes(key)
            ? stripCommas(row[index])
            : row[index];
        });
        return obj;
      });

      setDisableField(false);
      await verifyExcelData(dataObjects);
    } catch (error) {
      setLoadingResponse(false);
      console.error(error);
      swal({
        title: "Error",
        text: error.message || "Failed to process file",
        icon: "error",
      });
    }
  };

  const verifyExcelData = async (data) => {
    if (!data || data.length === 0) {
      swal({
        title: "Error",
        text: "No data to verify",
        icon: "error",
      });
      return;
    }

    setPercentageLoader(true);
    const currentDate = new Date();
    const date = moment(currentDate).format("YYYY-MM-DD");

    try {
      const { userIp, userCountry } = ipCountry;

      const response = await axios.post(
        `${baseurl}/pointOfSale/verifyInvenOpnExcelData`,
        {
          companyId,
          excelData: data,
          date,
          username,
          userIp,
          userCountry,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );

      const responseData = response.data.data || [];
      const isInvalidValue = (val) =>
        val === null ||
        val === undefined ||
        val === "" ||
        val === "null" ||
        val === "more than one" ||
        val === "Invalid";

      // Number("") is 0, so blanks are rejected explicitly. Before this check
      // a qty like "abc" passed as a good row and was saved as 0.
      const isNumeric = (val) =>
        !isInvalidValue(val) &&
        String(val).trim() !== "" &&
        !isNaN(Number(val));

      // Shared by the good-row and bad-row passes so the two can't disagree.
      // A blank rate is allowed (amount then comes from the sheet), but a rate
      // that is filled in and not a number makes the row bad.
      const checkRowNumbers = (inputMaster) => {
        const hasValidQty = isNumeric(inputMaster.qty);
        const hasValidRate =
          isInvalidValue(inputMaster.rate) || isNumeric(inputMaster.rate);

        let amount = inputMaster.amount;
        if (hasValidQty && isNumeric(inputMaster.rate)) {
          amount = parseFloat(inputMaster.qty) * parseFloat(inputMaster.rate);
        }
        const hasValidAmount = isNumeric(amount);

        return { hasValidQty, hasValidRate, amount, hasValidAmount };
      };

      const groupedGoodRows = responseData
        .map((item, index) => {
          const masterResult = item;
          const inputMaster = data[index] || {};

          const hasIdentifier =
            !isInvalidValue(inputMaster.Item_code) ||
            !isInvalidValue(inputMaster.Item_name);

          const isMasterDataValid =
            !isInvalidValue(inputMaster.branch) && hasIdentifier;

          console.log("Master Result:", masterResult);
          const isBranchValid = !isInvalidValue(masterResult.Branch_id);
          const hasValidItemId = !isInvalidValue(masterResult.item_id);

          const hasValidCode = !isInvalidValue(masterResult.code);

          const hasValidBatchDocNo = !isInvalidValue(inputMaster.Batch_Doc_No);

          const { hasValidQty, hasValidRate, amount, hasValidAmount } =
            checkRowNumbers(inputMaster);

          const masterValid =
            isMasterDataValid &&
            isBranchValid &&
            hasValidItemId &&
            hasValidCode &&
            hasValidAmount &&
            hasValidBatchDocNo &&
            hasValidQty &&
            hasValidRate;

          if (!masterValid) return null;

          return {
            branch: inputMaster.branch,
            Item_code: inputMaster.Item_code,
            Item_name: inputMaster.Item_name,
            qty: inputMaster.qty,
            rate: inputMaster.rate,
            amount,
            Branch_id: masterResult.Branch_id,
            Item_id: masterResult.item_id,
            Batch_Doc_No: inputMaster.Batch_Doc_No,
          };
        })
        .filter(Boolean);

      const groupedBadRows = responseData
        .map((item, index) => {
          const masterResult = item || {};
          const inputMaster = data[index] || {};

          const hasIdentifier =
            !isInvalidValue(inputMaster.Item_code) ||
            !isInvalidValue(inputMaster.Item_name);

          const { hasValidQty, hasValidRate, amount, hasValidAmount } =
            checkRowNumbers(inputMaster);

          const isBranchValid =
            masterResult.Branch_id &&
            masterResult.Branch_id !== "null" &&
            masterResult.Branch_id !== "more than one";

          const isItemValid =
            masterResult.item_id &&
            masterResult.item_id !== "null" &&
            masterResult.item_id !== "more than one";

          const isCodeValid =
            masterResult.code &&
            masterResult.code !== "null" &&
            masterResult.code !== "more than one";

          const isBatchDocNoValid =
            inputMaster.Batch_Doc_No &&
            inputMaster.Batch_Doc_No !== "null" &&
            inputMaster.Batch_Doc_No !== "more than one";

          // 🔴 If all master values valid → NOT a bad row
          if (
            hasIdentifier &&
            isBranchValid &&
            isItemValid &&
            isCodeValid &&
            hasValidQty &&
            hasValidRate &&
            isBatchDocNoValid &&
            hasValidAmount
          ) {
            return null;
          }

          // 🟡 BAD ROW
          return {
            branch: inputMaster.branch || "Invalid",
            Item_code: inputMaster.Item_code || "Invalid",
            Item_name: inputMaster.Item_name || "Invalid",
            qty: inputMaster.qty || "null",
            rate: inputMaster.rate || "null",
            amount: amount || "null",

            Branch_id: masterResult.Branch_id || "Invalid",
            Item_id: masterResult.item_id || "Invalid",
            code: masterResult.code || "Invalid",
            Batch_Doc_No: masterResult.Batch_Doc_No || "Invalid",

            isInvalidBranch: !isBranchValid,
            isInvalidItem: !isItemValid,
            isInvalidCode: !isCodeValid,
            isInvalidQty: !hasValidQty,
            isInvalidAmount: !hasValidAmount,
            isInvalidRate: !hasValidRate,
            isInvalidBatchDocNo: !isBatchDocNoValid,
          };
        })
        .filter(Boolean);

      setLoadingResponse(false);
      setPercentageLoader(false);
      setGoodRows(groupedGoodRows);
      setBadRows(groupedBadRows);
      setShowQty(true);

      swal({
        title: "Done",
        text: `Excel verification completed. ${groupedGoodRows.length} valid rows, ${groupedBadRows.length} invalid rows.`,
        icon: "success",
      });
    } catch (error) {
      console.error("Error in verifyExcelData:", error);
      setLoadingResponse(false);
      setPercentageLoader(false);

      swal({
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong, try to refresh the page and try again.",
        icon: "error",
      });
    }
  };

  const getIpCountry = async () => {
    try {
      const res = await GetIp();
      setIpCountry({ userIp: res.ip, userCountry: res.country });
    } catch (error) {
      console.error("Error getting IP country:", error);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (goodRows.length === 0) return;

    setLoadingResponse(true);
    try {
      const { userIp, userCountry } = ipCountry;
      const res = await axios.post(
        `${baseurl}/pointOfSale/addImportInvenOpnData`,
        {
          companyId,
          invenOpn: goodRows,
          fileName: fileName,
          username,
          userIp,
          userCountry,
        },
        {
          headers: {
            authorization: token,
          },
        },
      );

      const { dublicate, message } = res.data;
      setLoadingResponse(false);

      if (dublicate) {
        swal({
          title: "Warning",
          text: message,
          icon: "warning",
        });
      } else {
        swal({
          title: "Saved Successfully!",
          text: "Item Inventory Open Added",
          icon: "success",
        }).then(() => {
          Redirect("/invOpnBlnOverview");
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setLoadingResponse(false);
      swal({
        title: "Warning",
        text: "Something went wrong, try to refresh the page, Check Duplicate Entry and try again.",
        icon: "warning",
      });
    }
  };

  const headers = [
    "Branch",
    "Branch_id",
    "Item_code",
    "Item_name",
    "Quantity",
    "Rate",
    "Item_id",
    "Batch Doc No",
  ];

  return (
    <>
      {loadingResponse || percentageLoader ? (
        <ResponseLoader percentage={percentageLoader} />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <strong>
                <h4>Import Item Inventory Open Sheet</h4>
              </strong>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div style={{ textAlign: "right" }}>
                <Link
                  to="/invOpnBlnOverview"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>
          <div className="mt-3">
            <div className="row">
              <div className="col-2 mt-1">
                <a href={ItemInvenOpn} download>
                  Download example CSV
                </a>
              </div>
              <div className="col-2 mt-1">
                <b>Max Batch Doc No: {maxBatchNo}</b>
              </div>
            </div>
            <FormGroup>
              <div className="row">
                <div className="col-11">
                  <CustomInput
                    type="file"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    accept=".csv,.xlsx"
                    required
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-1">
                  <span className="d-flex flex-row-reverse">
                    <Button
                      className="mr-1 btn-outline-primary"
                      onClick={handleOnChangeFile}
                    >
                      Import
                    </Button>
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <Button
                    hidden={goodRows.length === 0 && badRows.length === 0}
                    className={`mr-1 mt-1 ${
                      showBadRows ? "btn-outline-success" : "btn-outline-danger"
                    }`}
                    onClick={() => setShowBadRows(!showBadRows)}
                  >
                    Show {showBadRows ? "Good" : "Bad"} Rows
                  </Button>
                </div>
                {showQty && (
                  <div className="col-4 mt-2">
                    <span style={{ color: "green" }}>
                      No of Good Rows: {goodRows.length}
                    </span>
                    &nbsp;
                    <span style={{ color: "red" }}>
                      No of Bad Rows: {badRows.length}
                    </span>
                  </div>
                )}
              </div>
            </FormGroup>

            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  {showQty && (
                    <tr>
                      {headers.map((header, index) => (
                        <th style={{ border: "1px solid black" }} key={index}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  )}
                </thead>
                <tbody>
                  {(showBadRows ? badRows : goodRows).map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td
                        style={{
                          backgroundColor:
                            row.Branch_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.branch}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.Branch_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.Branch_id}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.Item_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.Item_code}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.Item_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.Item_name}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.amount === "null" || row.isInvalidQty
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.qty}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.amount === "null" || row.isInvalidRate
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.rate}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.Item_id === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.Item_id}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            row.Batch_Doc_No === "Invalid"
                              ? "#FF0000"
                              : "transparent",
                        }}
                      >
                        {row.Batch_Doc_No}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <hr
              style={{
                border: "1px solid",
                marginBottom: "3vh",
                marginTop: "1vh",
                borderColor: "#E4E5E6",
              }}
            />
            <div className="col-md-12 d-flex flex-row-reverse">
              <FormGroup>
                {((crumble && !badRows.length > 0) || !crumble) && (
                  <Button
                    onClick={handleSubmit}
                    className="mr-1 invoiceSubmitButton"
                    disabled={goodRows.length === 0}
                  >
                    Save Changes
                  </Button>
                )}
                <Link to={{ pathname: "/invOpnBlnOverview" }}>
                  <Button className="mr-1" size="sm">
                    Cancel
                  </Button>
                </Link>
              </FormGroup>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
